import { render, staticRenderFns } from "./ResultCcbill.vue?vue&type=template&id=54603d5a&scoped=true&"
import script from "./ResultCcbill.vue?vue&type=script&lang=js&"
export * from "./ResultCcbill.vue?vue&type=script&lang=js&"
import style0 from "./ResultCcbill.vue?vue&type=style&index=0&id=54603d5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54603d5a",
  null
  
)

export default component.exports